import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SignOut, Key, List, Sun, Moon } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { ChangePasswordDialog } from "./ChangePasswordDialog";

export const Header = ({ onToggleSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [pwdDialogOpen, setPwdDialogOpen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem("areapaq_theme") || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("light", theme === "light");
    localStorage.setItem("areapaq_theme", theme);
  }, [theme]);

  useEffect(() => {
    if (user?.must_change_password) setPwdDialogOpen(true);
  }, [user?.must_change_password]);

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="sticky top-0 z-30 bg-canvas/70 backdrop-blur-xl backdrop-saturate-150 border-b border-white/10 pt-[env(safe-area-inset-top)]">
      <div className="px-4 sm:px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            data-testid="sidebar-toggle-button"
            onClick={onToggleSidebar}
            className="md:hidden text-white/70 hover:text-white"
            title="Menu"
          >
            <List size={20} />
          </button>
          <span className="md:hidden font-heading font-bold text-lg tracking-tighter text-white" data-testid="header-logo">
            AREAPAQ
          </span>
        </div>
        <div className="flex items-center gap-3">
          <span className="hidden sm:block text-xs text-white/40" data-testid="header-user-email">{user?.email}</span>
          <Button
            variant="ghost"
            data-testid="theme-toggle-button"
            onClick={() => setTheme((t) => (t === "dark" ? "light" : "dark"))}
            className="text-white/70 hover:text-white hover:bg-white/5 rounded-full h-9 w-9 p-0"
            title={theme === "dark" ? "Tema chiaro" : "Tema scuro"}
          >
            {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
          </Button>
          <Button
            variant="ghost"
            data-testid="change-password-button"
            onClick={() => setPwdDialogOpen(true)}
            className="text-white/70 hover:text-white hover:bg-white/5 rounded-full h-9 w-9 p-0"
            title="Cambia password"
          >
            <Key size={16} />
          </Button>
          <Button
            data-testid="logout-button"
            onClick={handleLogout}
            className="bg-white text-black hover:bg-gray-200 rounded-full h-9 px-4 text-xs font-semibold tracking-wide"
          >
            <SignOut size={16} className="mr-1" /> Logout
          </Button>
        </div>
      </div>
      <ChangePasswordDialog open={pwdDialogOpen} onOpenChange={setPwdDialogOpen} />
    </header>
  );
};
